import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/seanrioux/products/open-source-okr/code/react-okr-ui/node_modules/gatsby-theme-docz/src/base/Layout.js";
import Objective from "../components/Objective";
import Progress from "../components/Progress";
import Result from "../components/Result";
import Current from "../components/Current";
import Score from "../components/Score";
import Goal from "../components/Goal";
import Due from "../components/Due";
import Okr from "../components/Okr";
import Row from "../components/Row";
import { Playground, Props } from "docz";
import { dateOptions, metrics, results, grades } from "../data/example.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "components"
    }}>{`Components`}</h1>
    <p>{`React OKR UI provides a collection of highly compositional components for a wide range of possible OKR UI requirements.`}</p>
    <p>{`Here's a live example. Adjust values in the Playground area to test how the components work and it's props work.`}</p>
    <Playground __position={0} __code={'() => {\n  // Setup metrics\n  const metrics = [\n    {\n      id: \'1\',\n      name: \'product revenue\',\n      prefix: \'\',\n      suffix: \'%\',\n      space: false, // Fix\n      allowNegative: false,\n      decimalScale: 2,\n    },\n  ]\n  // Set grades\n  const grades = [\n    {\n      id: \'1\',\n      name: \'Fail\',\n      range: [0.0, 0.75],\n      color: \'#ef4444\',\n    },\n    {\n      id: \'2\',\n      name: \'Pass\',\n      range: [0.75, 2.0],\n      color: \'#10b981\',\n    },\n  ]\n  return (\n    <Okr metrics={metrics} grades={grades}>\n      <Objective>\n        <Row type=\"flex\">\n          <Goal label=\"Objective\" text=\"Carve out a niche\" />\n          <Due\n            label=\"Due date\"\n            date=\"2022/01/01\"\n            options={{ year: \'numeric\', month: \'short\', day: \'numeric\' }}\n          />\n        </Row>\n        <Progress label=\"progress\" value={0.75} />\n        <Result>\n          <Row type=\"flex\">\n            <Goal\n              label=\"Key Result\"\n              direction=\"increase\"\n              metricId=\"1\"\n              start={20}\n              end={50}\n            />\n            <Row type=\"flex\">\n              <Current\n                className=\"okr-mr-1\"\n                label=\"Current\"\n                metricId=\"1\"\n                value={30}\n              />\n              <Score\n                className=\"okr-ml-1\"\n                direction=\"increase\"\n                start={20}\n                end={50}\n                current={30}\n                circle\n              />\n            </Row>\n          </Row>\n        </Result>\n      </Objective>\n    </Okr>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Objective,
      Progress,
      Result,
      Current,
      Score,
      Goal,
      Due,
      Okr,
      Row,
      Playground,
      Props,
      dateOptions,
      metrics,
      results,
      grades,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	{() => {
        // Setup metrics
        const metrics = [{
          id: "1",
          name: "product revenue",
          prefix: "",
          suffix: "%",
          space: false,
          // Fix
          allowNegative: false,
          decimalScale: 2
        }]; // Set grades

        const grades = [{
          id: "1",
          name: "Fail",
          range: [0.0, 0.75],
          color: "#ef4444"
        }, {
          id: "2",
          name: "Pass",
          range: [0.75, 2.0],
          color: "#10b981"
        }];
        return <Okr metrics={metrics} grades={grades} mdxType="Okr">
				<Objective mdxType="Objective">
					<Row type="flex" mdxType="Row">
						<Goal label="Objective" text="Carve out a niche" mdxType="Goal" />
						<Due label="Due date" date="2022/01/01" options={{
                year: "numeric",
                month: "short",
                day: "numeric"
              }} mdxType="Due" />
					</Row>
					<Progress label="progress" value={0.75} mdxType="Progress" />
					<Result mdxType="Result">
						<Row type="flex" mdxType="Row">
							<Goal label="Key Result" direction="increase" metricId="1" start={20} end={50} mdxType="Goal" />
							<Row type="flex" mdxType="Row">
								<Current className="okr-mr-1" label="Current" metricId="1" value={30} mdxType="Current" />
								<Score className="okr-ml-1" direction="increase" start={20} end={50} current={30} circle mdxType="Score" />
							</Row>
						</Row>
					</Result>
				</Objective>
			</Okr>;
      }}
    </Playground>
    <hr></hr>
    <h2 {...{
      "id": "okr"
    }}>{`Okr`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`<Okr>`}</inlineCode>{` component acts as a general countainer wrapper:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Okr metrics={metrics} grades={grades}>
    {children}
</Okr>
`}</code></pre>
    <h3 {...{
      "id": "properties"
    }}>{`Properties`}</h3>
    <p>{`Okr has the properties:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`metrics`}</inlineCode>{`: i.e., the things you are measuring as results`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`grades`}</inlineCode>{`: i.e., how scores are interpreted e.g., `}<inlineCode parentName="li">{`pass`}</inlineCode>{` or `}<inlineCode parentName="li">{`fail`}</inlineCode></li>
    </ul>
    <Props of={Okr} mdxType="Props" />
    <h4 {...{
      "id": "example-metrics-and-grades"
    }}>{`Example metrics and grades`}</h4>
    <p>{`Here is some example configuration:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// Metrics
const metrics = [
    {
        id: "1",
        name: "product revenue",
        prefix: "",
        suffix: "%",
        space: false, // Fix
        allowNegative: false,
        decimalScale: 2,
    },
];

// Grades
const grades = [
    {
        id: "1",
        name: "Fail",
        range: [0.0, 0.75],
        color: "#ef4444",
    },
    {
        id: "2",
        name: "Pass",
        range: [0.75, 2.0],
        color: "#10b981",
    },
];
`}</code></pre>
    <hr></hr>
    <h2 {...{
      "id": "objective"
    }}>{`Objective`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`<Objective>`}</inlineCode>{` component provides a wrapper for each objective:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Objective className="card">{children}</Objective>
`}</code></pre>
    <h3 {...{
      "id": "properties-1"
    }}>{`Properties`}</h3>
    <p>{`The component takes a className and passes it on to the component:`}</p>
    <Props of={Objective} mdxType="Props" />
    <hr></hr>
    <h2 {...{
      "id": "result"
    }}>{`Result`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`<Result>`}</inlineCode>{` component provides a wrapper for each result:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Result className="card">{children}</Result>
`}</code></pre>
    <h3 {...{
      "id": "properties-2"
    }}>{`Properties`}</h3>
    <p>{`The component takes a className and passes it on to the component.`}</p>
    <Props of={Result} mdxType="Props" />
    <hr></hr>
    <h2 {...{
      "id": "goal"
    }}>{`Goal`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`<Goal>`}</inlineCode>{` component displays the goal text, either by processing the result object properties or simply taking objective text.`}</p>
    <Playground __position={4} __code={'<Okr metrics={metrics} grades={grades}>\n  <Objective>\n    <Goal label=\"Objective\" text=\"Carve out a niche\" />\n    <Result>\n      <Goal\n        label=\"Key Result\"\n        direction=\"increase\"\n        metricId=\"1\"\n        start={20}\n        end={50}\n      />\n    </Result>\n  </Objective>\n</Okr>'} __scope={{
      props,
      DefaultLayout,
      Objective,
      Progress,
      Result,
      Current,
      Score,
      Goal,
      Due,
      Okr,
      Row,
      Playground,
      Props,
      dateOptions,
      metrics,
      results,
      grades,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<Okr metrics={metrics} grades={grades} mdxType="Okr">
		<Objective mdxType="Objective">
			<Goal label="Objective" text="Carve out a niche" mdxType="Goal" />
			<Result mdxType="Result">
				<Goal label="Key Result" direction="increase" metricId="1" start={20} end={50} mdxType="Goal" />
			</Result>
		</Objective>
	</Okr>
    </Playground>
    <h3 {...{
      "id": "properties-3"
    }}>{`Properties`}</h3>
    <p>{`The component takes objective properties to calculate the goal or simply text. It also includes an optional label:`}</p>
    <Props of={Goal} mdxType="Props" />
    <h2 {...{
      "id": "due"
    }}>{`Due`}</h2>
    <p>{`Input any parsable date string (or timestamp) to display the date. Customize using options:`}</p>
    <Playground __position={6} __code={'<Due\n  label=\"Due date\"\n  date=\"2022/01/01\"\n  options={{ year: \'numeric\', month: \'short\', day: \'numeric\' }}\n/>'} __scope={{
      props,
      DefaultLayout,
      Objective,
      Progress,
      Result,
      Current,
      Score,
      Goal,
      Due,
      Okr,
      Row,
      Playground,
      Props,
      dateOptions,
      metrics,
      results,
      grades,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<Due label="Due date" date="2022/01/01" options={{
        year: "numeric",
        month: "short",
        day: "numeric"
      }} mdxType="Due" />
    </Playground>
    <h2 {...{
      "id": "progress"
    }}>{`Progress`}</h2>
    <p>{`Progress indicator for objectives, calculated from result scores or input as a percentage value.`}</p>
    <Playground __position={7} __code={'<Okr metrics={metrics} grades={grades}>\n  <Objective>\n    <Progress label=\"progress\" value={0.75} />\n    <Progress label=\"progress\" results={results} />\n  </Objective>\n</Okr>'} __scope={{
      props,
      DefaultLayout,
      Objective,
      Progress,
      Result,
      Current,
      Score,
      Goal,
      Due,
      Okr,
      Row,
      Playground,
      Props,
      dateOptions,
      metrics,
      results,
      grades,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<Okr metrics={metrics} grades={grades} mdxType="Okr">
		<Objective mdxType="Objective">
			<Progress label="progress" value={0.75} mdxType="Progress" />
			<Progress label="progress" results={results} mdxType="Progress" />
		</Objective>
	</Okr>
    </Playground>
    <h3 {...{
      "id": "properties-4"
    }}>{`Properties`}</h3>
    <p>{`Takes either a percentage value, or an array of results.`}</p>
    <Props of={Progress} mdxType="Props" />
    <h3 {...{
      "id": "results-example"
    }}>{`Results example`}</h3>
    <p>{`Here is how to structure your results in an array:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`    const results = [
        id: "1",
        metricId: "1",
        direction: "increase",
        start: 50,
        end: 10,
        current: 20,
    },
]
`}</code></pre>
    <h2 {...{
      "id": "current"
    }}>{`Current`}</h2>
    <p>{`Display the current result value.`}</p>
    <Playground __position={9} __code={'<Okr metrics={metrics} grades={grades}>\n  <Objective>\n    <Result>\n      <Current label=\"Current\" metricId=\"1\" value={30} />\n    </Result>\n  </Objective>\n</Okr>'} __scope={{
      props,
      DefaultLayout,
      Objective,
      Progress,
      Result,
      Current,
      Score,
      Goal,
      Due,
      Okr,
      Row,
      Playground,
      Props,
      dateOptions,
      metrics,
      results,
      grades,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<Okr metrics={metrics} grades={grades} mdxType="Okr">
		<Objective mdxType="Objective">
			<Result mdxType="Result">
				<Current label="Current" metricId="1" value={30} mdxType="Current" />
			</Result>
		</Objective>
	</Okr>
    </Playground>
    <h3 {...{
      "id": "properties-5"
    }}>{`Properties`}</h3>
    <p>{`Takes the current value from the result and the metricId to format the number.`}</p>
    <Props of={Current} mdxType="Props" />
    <h2 {...{
      "id": "score"
    }}>{`Score`}</h2>
    <p>{`Score the result based on start, end (goal), and current value.`}</p>
    <Playground __position={11} __code={'<Okr metrics={metrics} grades={grades}>\n  <Objective>\n    <Result>\n      <Score\n        label=\"score\"\n        direction=\"increase\"\n        start={20}\n        end={50}\n        current={30}\n        circle\n      />\n    </Result>\n  </Objective>\n</Okr>'} __scope={{
      props,
      DefaultLayout,
      Objective,
      Progress,
      Result,
      Current,
      Score,
      Goal,
      Due,
      Okr,
      Row,
      Playground,
      Props,
      dateOptions,
      metrics,
      results,
      grades,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<Okr metrics={metrics} grades={grades} mdxType="Okr">
		<Objective mdxType="Objective">
			<Result mdxType="Result">
				<Score label="score" direction="increase" start={20} end={50} current={30} circle mdxType="Score" />
			</Result>
		</Objective>
	</Okr>
    </Playground>
    <h3 {...{
      "id": "properties-6"
    }}>{`Properties`}</h3>
    <p>{`Takes result properties, as well as a `}<inlineCode parentName="p">{`label`}</inlineCode>{`, and `}<inlineCode parentName="p">{`className`}</inlineCode>{`. Can display as a `}<inlineCode parentName="p">{`circle`}</inlineCode>{` which uses the score grade to determine its background color.`}</p>
    <Props of={Score} mdxType="Props" />
    <h2 {...{
      "id": "row"
    }}>{`Row`}</h2>
    <p>{`A flex row utility component (very optional).`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Row type="flex">{children}</Row>
`}</code></pre>
    <h3 {...{
      "id": "properties-7"
    }}>{`Properties`}</h3>
    <p>{`Use to layout your row using `}<inlineCode parentName="p">{`flex`}</inlineCode>{` or `}<inlineCode parentName="p">{`wrap`}</inlineCode>{`.`}</p>
    <Props of={Row} mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      